import {
    type AfterViewInit,
    Component,
    inject,
    ChangeDetectionStrategy,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DATA_QAA, dataQaaPrefix } from "@firm360/libs/observability/data-qaa";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-404",
    templateUrl: "404.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    hostDirectives: [DATA_QAA],
})
export class P404Component implements AfterViewInit {
    protected readonly qaaPrefix = dataQaaPrefix(P404Component);
    private modalService = inject(NgbModal);
    private activatedRoute = inject(ActivatedRoute);

    errorType: string;

    constructor() {
        this.errorType = this.activatedRoute.snapshot.params["error-type"];
    }

    ngAfterViewInit() {
        this.modalService.dismissAll();
    }
}
